export class CnsStamp {
    bussinessinfo = new Bussinessinfo();
    content = new Content();
    envelope = new Envelope();
}
export class Bussinessinfo {
    field = new Field();
}
export class InputFile {
    nome: any;
    extensaoValida: boolean;
    mensagemErro: String;
    mensagemSucesso: String;
    valueProgress: number;
    fileList: FileList;
}
export class Field {
    competencia: number;
    dataRecol: number;
    emailResp: string;
    imprimeGuia: string;
    inscEmpresa: number;
    inscResponsavel: number;
    lacreCns: string;
    nomeContato: string;
    nomeResp: string;
    nra: string;
    qtdEmpresas: number;
    recolhimento: number;
    reg00: string;
    reg10: string;
    reg11: string;
    reg14: string;
    reg86: string;
    reg90: string;
    regr: string;
    telefone: number;
    tpinscEmpresa: number;
    tpinscResponsavel: number;
    versaoSefip: string;
}

export class ManifestoSefip {
    Funcionalidade: any;
    VersaoSefip: any;
    FileVersion: any;
    Idms: any;
    Versao: any;
    Ambiente: any;
    Detalhe: any;
    Competencia: any;
    CodigoArrecadacao: any;
    CodigoCertificado: any;
    NomeCertificado: any;
    TipoInscricao: any;
    Inscricao: any;  
    NomeResponsavel: any;
    InscricaoResponsavel: any;
    TipoInscResponsavel: any;
    CpfRemetente: any;
    Contato: any;
    Telefone: any;
    InscricaoEmpresas: any;
    Municipio: any;
    Uf: any;
    Base: any;
    NomeMensagem: any;
    Sign: any;
    NomeArquivoFisico: any;
    Protocolo: any;
    EnderecoIp: any;
    ProtocoloXML: any;
    CodMaquina: any;
   
}

export class ManifestoGrrf {
    Funcionalidade: any;
    dataRecolhimento: any;
    InscricaoEmpresas: any;
    Tipo: any;
    Idms: any;
    Versao: any;
    VersaoGrrf: any;
    FileVersion: any;
    Detalhe: any;
    TipoInscricao: any;
    CodigoCertificado: any;
    Ambiente: any;
    CodigoArrecadacao: any;
    NomeCertificado: any;
    Inscricao: any;
    Sign: any;
    EnderecoIp: any;
    Uf: any;
    CpfRemetente: any;
    Base: any;
    Municipio: any;
    Contato: any;
    NomeArquivoFisico: any;
    NomeMensagem: any;
    Protocolo: any;
    NomeResponsavel: any;
    InscricaoResponsavel: any;
    TipoInscResponsavel: any;
    ContentId: any;
}

export class Arquivo {
    payload: any;
    nome: string;
}

export class ArquivoEnvio {
  arquivoHash: any;
  seloXml: any;
  totalizador: any;
  arquivoRe = new Arquivo();
}

export class Content {
    file = new File();
}
export class File {
    name: string;
}
export class Envelope {
    nomeArquivoRetorno: string;
    requiredLevel: number;
}

export class Protocolo {
    codProtocolo: string;
    razaoSocial: string;
    inscricao: string;
    responsavel: string;
    competencia: string;
    baseProcessamento: string;
    codArrecadacao: string;
    contato: string;
    telefone: string;
    nra: string;
    cpfResponsavel: string;
    nomeArquivo: string;
    data: string;
    hora: string;
    dadosProtocolos: Protocolo;
    servico: number;
}

export class RetornoEnvio {
    status: boolean;
    nra: string;
    competencia: string;
    contato: string;
    telefone: string;
}
